import i18next from 'i18next';
import { USER_MESSAGE_TYPES } from '../../../flows/UserMessageFlow/constants';
import { useStore } from '../../../store';
import { IServerErrorResponse } from '../../../types';
import { ACH_OUT_ERRORS } from '../constants';
import IconHappyDollar from '../../../assets/icons/svg/stamp-icons/ic-stamp-happy-dollar.svg';
import { AlertIcon } from '../../../assets/svg';
import { VIEWS_MAP } from '../../../router/constants';
import { DYNAMIC_FORM_TYPES } from '../../../components/form/dynamicForm/types';

const { setMessageObject } = useStore.getState();
const { INSUFFICIENT_BALANCE_CODE_NAME, INSUFFICIENT_BALANCE_CODE, INVALID_ROUTING_NUMBER_CODE, BILL_ALREADY_PAID } =
  ACH_OUT_ERRORS;

export const handleOnAchOutError = (
  data: IServerErrorResponse,
  navigate: any,
  supplierId: string,
  transferAmount: string,
) => {
  const { t } = i18next;
  const errorCode = data?.response?.data?.errors?.[0]?.code;
  const codeName = data?.response?.data?.errors?.[0]?.codeName;
  const messageText = data?.response?.data?.errors?.[0]?.message ?? '';
  if (errorCode === INVALID_ROUTING_NUMBER_CODE) {
    setMessageObject({
      popupHeight: 'h-[320px]',
      pictureClassName: 'w-[76px] h-[76px] mb-[20px]',
      containerClassName: 'w-[418px] pt-[34px] pb-[24px] px-[24px] justify-between',
      titleClassName: 'text-[20px] leading-7 font-metricRMedium text-bw08 mb-[8px]',
      messageTextClassName: 'font-metricR text-md text-bw07 leading-6 mb-[22px] whitespace-pre-line',
      buttonClassName: 'w-[370px] h-[58px] flex items-center justify-center rounded-umd bg-action03 hover:bg-action04',
      mainButtonClassName: 'font-metricRMedium text-bw00 text-md leading-6',
      type: USER_MESSAGE_TYPES.POP_UP,
      iconSource: AlertIcon,
      messageTitle: t('ACH_OUT_SERVER_ERRORS.INVALID_ROUTING_NUMBER.TITLE'),
      messageText: t('ACH_OUT_SERVER_ERRORS.INVALID_ROUTING_NUMBER.TEXT'),
      mainButtonText: t('ACH_OUT_SERVER_ERRORS.INVALID_ROUTING_NUMBER.CTA'),
      callback: () => {
        setMessageObject({ type: USER_MESSAGE_TYPES.ZERO_STATE });
        navigate(`/${VIEWS_MAP.SUPPLIER.BASE}/${VIEWS_MAP.SUPPLIER.MANAGE.BASE}/${supplierId}`, {
          replace: true,
          state: {
            pageTitle: t('ACH_OUT_NEW.HEADER_TITLE'),
            formHeader: t('ACH_OUT_NEW_MISSING_DETAILS.TITLE'),
            formType: DYNAMIC_FORM_TYPES.ACH_OUT_MANDATORY,
            onExitDestination: `/${VIEWS_MAP.DASHBOARD}`,
            isUpdateOnlyMode: true,
            transferAmount,
          },
        });
      },
    });
  } else if (errorCode === INSUFFICIENT_BALANCE_CODE || codeName === INSUFFICIENT_BALANCE_CODE_NAME) {
    setMessageObject({
      popupHeight: ' h-[420px]',
      pictureClassName: 'w-[84px] h-[84px] mb-[24px]',
      containerClassName: 'w-[400px] pt-[40px] pb-[20px] px-[10px] justify-between',
      type: USER_MESSAGE_TYPES.POP_UP,
      messageTitle: t('ACH_OUT_SERVER_ERRORS.INSUFFICIENT_BALANCE.TITLE'),
      titleClassName: 'text-base leading-[27px] font-metricMedium text-bw08 mb-[16px]',
      messageText: t('ACH_OUT_SERVER_ERRORS.INSUFFICIENT_BALANCE.TEXT'),
      messageTextClassName: 'font-metric text-base text-bw07 leading-[27px] mb-[10px] whitespace-pre-line',
      iconSource: IconHappyDollar,
      mainButtonText: t('ACH_OUT_SERVER_ERRORS.INSUFFICIENT_BALANCE.CTA'),
      buttonClassName:
        'w-[240px] h-[50px] flex items-center justify-center rounded-umd bg-action03 hover:bg-action04 font-metricMedium text-bw00 text-[14px] leading-[25px]',
      callback: () => setMessageObject({ type: USER_MESSAGE_TYPES.ZERO_STATE }),
    });
  } else if (errorCode === BILL_ALREADY_PAID) {
    setMessageObject({
      pictureClassName: 'w-[76px] h-[76px] mb-[20px]',
      containerClassName: 'w-[418px] h-[320px] pt-[34px] pb-[24px] px-[24px]',
      type: USER_MESSAGE_TYPES.POP_UP,
      messageTitle: t('ACH_OUT_SERVER_ERRORS.BILL_ALREADY_PAID.TITLE'),
      titleClassName: 'text-[20px] leading-7 font-metricRMedium text-bw08 mb-[8px]',
      messageText: t('ACH_OUT_SERVER_ERRORS.BILL_ALREADY_PAID.TEXT'),
      messageTextClassName: 'font-metricR text-md text-bw07 leading-6 mb-[22px]',
      iconSource: AlertIcon,
      mainButtonText: t('ACH_OUT_SERVER_ERRORS.BILL_ALREADY_PAID.CTA'),
      buttonClassName: 'w-full h-[58px] flex items-center justify-center rounded-umd bg-action03 hover:bg-action04',
      mainButtonClassName: 'font-metricRMedium text-bw00 text-md leading-6',
      callback: () => {
        setMessageObject({ type: USER_MESSAGE_TYPES.ZERO_STATE });
        navigate(`/${VIEWS_MAP.BILLS.BASE}`);
      },
    });
  } else {
    setMessageObject({
      pictureClassName: 'w-[84px] h-[84px] mb-[24px]',
      containerClassName: 'w-[400px] h-[400px] py-[30px] px-[30px]',
      type: USER_MESSAGE_TYPES.POP_UP,
      messageTitle: t('GENERAL_ERROR.TITLE'),
      titleClassName: 'text-base leading-[27px] font-metricMedium text-bw08 mb-[21px]',
      messageText,
      messageTextClassName: 'font-metric text-base text-bw07 leading-[27px] mb-[60px]',
      iconSource: IconHappyDollar,
      mainButtonText: t('GENERAL_ERROR.CTA'),
      buttonClassName:
        'w-[240px] h-[50px] flex items-center justify-center rounded-umd bg-action03 hover:bg-action04 font-metricMedium text-bw00 text-[14px] leading-[25px]',
      callback: () => setMessageObject({ type: USER_MESSAGE_TYPES.ZERO_STATE }),
    });
  }
};
